import React from 'react';

import { ZeosFontSize } from '../../../services/helpers/ThemeHelpers';

interface IProps {
  bodyContent: string;
  bodyHeading: string;
  buttonTitle?: string;
  children?: React.ReactNode;
  image?: string;
  setUnlocked: (unlocked: boolean) => void;
  title: string;
  unlocked: boolean;
  forceColor?: boolean;
  onExploreClick?: () => void;
  secondaryButtonTitle?: string;
  onSecondaryClick?: () => void;
}

export const LockedDashboardTile = (props: IProps) => {
  const {
    bodyContent,
    bodyHeading,
    buttonTitle,
    image,
    setUnlocked,
    title,
    forceColor,
    onExploreClick,
    secondaryButtonTitle,
    onSecondaryClick,
  } = props;
  const finalButtonTitle = buttonTitle || "Explore";
  const handleClick = () => {
    if (onExploreClick) {
      onExploreClick(); // navigate to the survey page
    } else {
      // setUnlocked(true);
    }
  };

  const primaryButtonClass = `cursor-pointer rounded px-2 py-1 text-white bg-zeos-orange-dk text-${ZeosFontSize.xs} grayscale group-hover:grayscale-0`;

  return (
    <div className="flex flex-col w-full font-sans group">
      <div className="flex">
        <div className="text-[1.2rem] mr-5 relative text-zeos-black bg-white rounded-t px-3 py-1">
          {title}
        </div>
      </div>
      <div className={`relative group w-full`}>
        <div className="h-[220px] w-full bg-white flex items-center">
          <div className="w-1/2 h-full flex flex-col justify-center pl-4 pr-4">
            <h3 className={`font-bold text-${ZeosFontSize.xl} leading-normal`}>
              {bodyHeading}
            </h3>
            <p className="text-sm">{bodyContent}</p>
            <div
              className={`mt-[10px] flex items-center gap-3 ${
                secondaryButtonTitle ? "justify-between" : ""
              }`}
            >
              <button className={primaryButtonClass} onClick={handleClick}>
                {finalButtonTitle}
              </button>
              {secondaryButtonTitle && (
                <button
                  className={primaryButtonClass}
                  onClick={() => onSecondaryClick?.()}
                >
                  {secondaryButtonTitle}
                </button>
              )}
            </div>
          </div>
          {image && (
            <div className="w-1/2 h-full">
              <img
                className="h-full w-full object-cover object-bottom transition-all duration-300 grayscale group-hover:grayscale-0"
                src={image}
                alt="image"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
